module.exports = __webpack_public_path__ + "static/media/HallOfGames_1920x1080.90b26189.png";